const CustomIconViewList = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="5.263"
      height="5.263"
      rx="1.316"
    />
    <rect
      x="7.37"
      width="12.632"
      height="5.263"
      rx="1.316"
    />
    <rect
      y="7.37"
      width="5.263"
      height="5.263"
      rx="1.316"
    />
    <rect
      x="7.37"
      y="7.37"
      width="12.632"
      height="5.263"
      rx="1.316"
    />
    <rect
      y="14.74"
      width="5.263"
      height="5.263"
      rx="1.316"
    />
    <rect
      x="7.37"
      y="14.74"
      width="12.632"
      height="5.263"
      rx="1.316"
    />
  </svg>
)

export default CustomIconViewList
